0
<template>
    <div class="whiteBG radius pt-md-3">
        <div class="row justify-content-center d-flex">
            <div class="col-12 col-md-10">
                <div class="d-flex justify-content-center dwPlatform">
                   
                    <div class="PlatformOuter mb-3">
                        <div class="platformico text-center">
                            <img src="../../../../static/fxView/images/acttrader_platform.png" alt="actTrader" />
                            <h3 class="mb-3">{{$t('dp_download')}} <span class="ml-md-1" v-html="$t('dp_actTrader')"></span></h3>
                        </div>
                        <div class="platfromdownload px-3 text-center mb-5">
                            <div class="downloadPlatformList">
                                <a title="Windows" @click="actTraderEventHandle('windows')" :href="$env_var.downloadPlatformLink1.ACT.window" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/windows.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_forWindows')}}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <a title="IOS" @click="actTraderEventHandle('ios')" :href="$env_var.downloadPlatformLink1.ACT.ios" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/ios.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_forIos')}}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <a title="Android" @click="actTraderEventHandle('android')" :href="$env_var.downloadPlatformLink1.ACT.android" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/android.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_forAndroid')}}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <div class="d-flex w-100 align-items-center">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/webtrader.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0 ml-auto">
                                        {{$t('dp_ActWebTrader')}}
                                        <div>
                                            <a title="Act Web Trader Live" @click="actTraderEventHandle('live')" :href="$env_var.downloadPlatformLink1.ACT.actLive" target="_blank">{{$t('dash_live')}} </a>
                                            <a title="Act Web Trader Demo" @click="actTraderEventHandle('demo')" :href="$env_var.downloadPlatformLink1.ACT.actDemo" target="_blank">{{$t('dash_demo')}} </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- downloadplatform end -->
                    <!-- <div class="PlatformOuter mb-3">
                        <div class="platformico text-center">
                            <img src="../../../../static/fxView/images/mt4_platform.png" alt="MT4" />
                            <h3 class="mb-3">{{$t('dp_download')}} <span class="ml-md-1">{{$t('welcm_MT4')}}</span></h3>
                        </div>
                        <div class="platfromdownload px-3 text-center">
                            <div class="downloadPlatformList">
                                <a title="Windows" @click="mt4EventHandle('windows')" :href="$env_var.downloadPlatformLink1.MT4.window">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/windows.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_forWindows')}}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <a title="IOS" @click="mt4EventHandle('ios')" :href="$env_var.downloadPlatformLink1.MT4.ios" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/ios.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_forIos')}}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <a title="Android" @click="mt4EventHandle('android')" :href="$env_var.downloadPlatformLink1.MT4.android" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/android.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_forAndroid')}}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <router-link @click.native="mt4EventHandle('webtrader')" :to="{path: $env_var.downloadPlatformLink1.MT4.webTraderInternalLink, query: { 'platform': 'MT4'}}" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/webtrader.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_MT4WebTrader')}}
                                    </div>
                                </router-link>
                            </div>
                            <div class="downloadPlatformList">
                                <a title="Android" @click="mt4EventHandle('mac')" :href="$env_var.downloadPlatformLink1.MT4.mac" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/mac_ico.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                         {{$t('dp_forMAC')}}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div> -->

                    <div class="PlatformOuter mb-3">
                        <div class="platformico text-center">
                            <img src="../../../../static/fxView/images/mt5_platform.png" alt="MT5" />
                            <h3 class="mb-3">{{$t('dp_download')}} <span class="ml-md-1">{{$t('welcm_MT5')}}</span></h3>
                        </div>
                        <div class="platfromdownload">
                            <div class="downloadPlatformList">
                                <a title="Windows" @click="mt5EventHandle('windows')" :href="$env_var.downloadPlatformLink1.MT5.window" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/windows.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_forWindows')}}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <a title="IOS" @click="mt5EventHandle('ios')" :href="$env_var.downloadPlatformLink1.MT5.ios" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/ios.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_forIos')}}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <a title="Android" @click="mt5EventHandle('android')" :href="$env_var.downloadPlatformLink1.MT5.android" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/android.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_forAndroid')}}
                                    </div>
                                </a>
                            </div>
                            <!-- <div class="downloadPlatformList">
                                <router-link :to="{path: '/web-trade-link' , query: { 'platform': 'MT5'}}" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/webtrader.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('dp_MT5WebTrader')}}
                                    </div>
                                </router-link>
                            </div> -->
                            <div class="downloadPlatformList">
                                <a title="Web Trader" @click="mt5EventHandle('demo')" :href="$env_var.downloadPlatformLink1.MT5.webdemo" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/webtrader.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{$t('fxMT5DemoWebTrader')}}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <a title="Web Trader" @click="mt5EventHandle('live')" :href="$env_var.downloadPlatformLink1.MT5.weblive" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/webtrader.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                        {{ $t('fxMT5LiveWebTrader') }}
                                    </div>
                                </a>
                            </div>
                            <div class="downloadPlatformList">
                                <a title="Android" @click="mt5EventHandle('mac')" :href="$env_var.downloadPlatformLink1.MT5.mac" target="_blank">
                                    <div class="thumb d-block">
                                        <img src="../../../../static/fxView/images/mac_ico.svg" alt="Icon" />
                                    </div>
                                    <div class="font-weight-normal mb-0">
                                       {{$t('dp_forMAC')}}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- downloadplatform end -->

                    
                    <!-- downloadplatform end -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Download-platform",
        data() {
            return {};           
        },
        methods: {
            actTraderEventHandle(event){
                switch (event) {
                case 'windows':
                    this.$trackEvent('CP+Download+ActTrader', 'For+Windows', 'edition');
                    break;
                case 'ios':
                    this.$trackEvent('CP+Download+ActTrader', 'For+iOS', 'edition');
                    break;
                case 'android':
                    this.$trackEvent('CP+Download+ActTrader', 'For+Android', 'edition');
                    break;
                case 'live':
                    this.$trackEvent('CP+Download+ActTrader', 'For+Live', 'edition');
                    break;
                case 'demo':
                    this.$trackEvent('CP+Download+ActTrader', 'For+Demo', 'edition');
                    break;
                }
            },  

            mt4EventHandle(event){
            switch (event) {
                case 'windows':
                    this.$trackEvent('CP+Download+MT4', 'For+Windows', 'edition');
                    break;
                case 'ios':
                    this.$trackEvent('CP+Download+MT4', 'For+iOS', 'edition');
                    break;
                case 'android':
                    this.$trackEvent('CP+Download+MT4', 'For+Android', 'edition');
                    break;
                case 'webtrader':
                    this.$trackEvent('CP+Download+MT4', 'MT4+Web+Trader', 'edition');
                    break;
                case 'mac':
                    this.$trackEvent('CP+Download+MT4', 'For+MAC', 'edition');
                    break;
                }
            },

            mt5EventHandle(event){
            switch (event) {
                case 'windows':
                    this.$trackEvent('CP+Download+MT5', 'For+Windows', 'edition');
                    break;
                case 'ios':
                    this.$trackEvent('CP+Download+MT5', 'For+iOS', 'edition');
                    break;
                case 'android':
                    this.$trackEvent('CP+Download+MT5', 'For+Android', 'edition');
                    break;
                case 'demo':
                    this.$trackEvent('CP+Download+MT5', 'MT5+Demo+Web+Trader', 'edition');
                    break;
                case 'live':
                    this.$trackEvent('CP+Download+MT5', 'MT5+Live+Web+Trader', 'edition');
                    break;
                case 'mac':
                    this.$trackEvent('CP+Download+MT5', 'For+MAC', 'edition');
                    break;
                }
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/fxView/users/downloadplatform.vue